"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toLocalInteraction = toLocalInteraction;
exports.toInteractionRecord = toInteractionRecord;

var _immutable = require("immutable");

/*
  Transforms an `InteractionRecord` to a `LocalInteraction` for local storage.
  Interactions that persist additional data should provide additional transforms.
*/
function toLocalInteraction(interactionRecord, localInteraction) {
  var rawEditorContent = null;

  if (interactionRecord.richTextEditorResults.hasContent()) {
    rawEditorContent = interactionRecord.richTextEditorResults.toRawEditorContent();
  }

  return localInteraction.set('rawEditorContent', rawEditorContent).set('savable', interactionRecord.savable).set('engagement', interactionRecord.engagement).set('metadata', interactionRecord.metadata).set('associations', interactionRecord.associations).set('selectedFollowUpCategory', interactionRecord.selectedFollowUpCategory).set('includeFollowUpTask', interactionRecord.includeFollowUpTask);
}

function toInteractionRecord(localInteraction, interactionRecord) {
  interactionRecord = interactionRecord.setObjectAssociation(localInteraction.get('associations'));
  return interactionRecord.set('rawEditorContent', localInteraction.get('rawEditorContent')).set('savable', localInteraction.get('savable')).set('engagement', localInteraction.get('engagement') || (0, _immutable.Map)()).set('metadata', localInteraction.get('metadata') || (0, _immutable.Map)()).set('includeFollowUpTask', localInteraction.get('includeFollowUpTask')).set('selectedFollowUpCategory', localInteraction.get('selectedFollowUpCategory'));
}